import React from 'react';

export default () => 
    <div>
        <h3>That page ain't real.</h3>
    </div>;


// WEBPACK FOOTER //
// ./src/NotFound.js